import { Collapse as UiCollapse, styled } from "@l2r-front/l2r-ui"

export const Collapse = styled(UiCollapse)({
    minHeight: "auto",
})

